import React from 'react'
import {
    BannerWrapper,
    BannerDiv,
    TitleDiv,
    Title,
    Prev,
    Next,
    Wrapper,
    Notfound
} from './TypeCategoriesBannerStyle'
import Data from './data.json'
import Carousel from "react-multi-carousel";
import { ArrowNext, ArrowPrev } from "../../components/AllSvgIcon";
import { useState, useEffect } from 'react';
import t from '../../i18n/translate'

const TypeCategoriesBanner = ({ deviceType, banners} ) => {
    let mql = window.matchMedia("all and (max-width: 769px)");
    const [showSlide, setShowSlide] = useState(true);
    const PrevButton = ({ onClick, children }) => {
        return (
            <Prev
                onClick={(e) => {
                    e.preventDefault();
                    onClick();
                }}
                className="prevButton"
            >
                {children}
            </Prev>
        );
    };
    const NextButton = ({ onClick, children }) => {
        return (
            <Next
                onClick={(e) => {
                    e.preventDefault();
                    onClick();
                }}
                className="nextButton"
            >
                {children}
            </Next>
        );
    };

    const ButtonGroup = ({ next, previous }) => {
        return (
            <Wrapper>
                <>
                    <PrevButton onClick={() => previous()}>
                        <ArrowPrev />
                    </PrevButton>
                    <NextButton onClick={() => next()}>
                        <ArrowNext />
                    </NextButton>
                </>

                {/* if prop isRtl true swap prev and next btn */}
            </Wrapper>
        );
    };

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1200 },
            items: 2,
            slidesToSlide: 2,
        },
        tablet: {
            breakpoint: { max: 1199, min: 768 },
            items: 2,
            slidesToSlide: 1,
        },
        mobile: {
            breakpoint: { max: 767, min: 0 },
            items: 1,
            slidesToSlide: 1,
        },
    };

    const [windowSize, setWindowSize] = useState([
        window.innerWidth,
        window.innerHeight,
    ]);

    useEffect(() => {
        const handleWindowResize = () => {
            setWindowSize([window.innerWidth, window.innerHeight]);
        };

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    });

    let getWindowSize = windowSize[0];

    return (
        <BannerWrapper>
            {banners.length !== 0 ?
                banners.length > 2 && getWindowSize > 720 ? (
                    <Carousel
                        arrows={false}
                        responsive={responsive}
                        deviceType={deviceType}
                        autoPlay={true}
                        autoPlaySpeed={4000}
                        infinite={true}
                        showDots={false}
                        customButtonGroup={<ButtonGroup />}
                        containerClass="container-for-promo"
                    >
                        {
                            banners.map((data, index) => (
                                <BannerDiv key={data.id} className="">
                                    <a href={data.web_link}>
                                        <img 
                                          src={data.image_link} 
                                          alt={data.title || 'Banner'} 
                                          fetchpriority={index < 2 ? "high" : "auto"}
                                          loading={index < 2 ? "eager" : "lazy"}
                                          decoding="async"
                                          width="600"
                                          height="400"
                                        />
                                        <TitleDiv>
                                            <Title>{data.title}</Title>
                                        </TitleDiv>
                                    </a>
                                </BannerDiv>
                            )
                            )
                        }
                    </Carousel>)
                    :
                    <>{banners.length >= 2 && getWindowSize < 720 ?
                        (<Carousel
                            arrows={false}
                            responsive={responsive}
                            deviceType={deviceType}
                            autoPlay={true}
                            autoPlaySpeed={4000}
                            infinite={true}
                            showDots={true}
                            customButtonGroup={<ButtonGroup />}
                            containerClass="container-for-promo"
                        >
                            {
                                banners.map((data, index) => (
                                    <BannerDiv key={data.id} className="mobile">
                                    <a href={data.web_link}>
                                        <img 
                                          src={data.image_link} 
                                          alt={data.title || 'Banner'} 
                                          fetchpriority={index === 0 ? "high" : "auto"}
                                          loading={index === 0 ? "eager" : "lazy"}
                                          decoding="async"
                                          width="600"
                                          height="400"
                                        />
                                        <TitleDiv>
                                            <Title>{data.title}</Title>
                                        </TitleDiv>
                                    </a>
                                </BannerDiv>
                                )
                                )
                            }
                        </Carousel>)
                        : banners.map((data, index) => (
                            <BannerDiv key={data.id} className="">
                            <a href={data.web_link}>
                                <img 
                                  src={data.image_link} 
                                  alt={data.title || 'Banner'} 
                                  fetchpriority={index === 0 ? "high" : "auto"}
                                  loading={index === 0 ? "eager" : "lazy"}
                                  decoding="async"
                                  width="600"
                                  height="400"
                                />
                                <TitleDiv>
                                    <Title>{data.title}</Title>
                                </TitleDiv>
                            </a>
                        </BannerDiv>
                        )
                        )
                    }
                    </>

                : <Notfound><h4>{t("error_product_not_found")}</h4></Notfound>}
        </BannerWrapper>
    )
}

export default TypeCategoriesBanner